import React, { type ReactNode } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// eslint-disable-next-line import/no-unassigned-import
import "swiper/css";
// eslint-disable-next-line import/no-unassigned-import
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper";
import { Box, type BoxProps } from "@chakra-ui/react";
import { type Theme } from "contexts/color-theme";

type SliderProps = {
  isBlog?: boolean;
  slides: ReactNode[];
  theme?: Theme;
} & BoxProps;

export function PaginatedSlider({ isBlog, slides, theme = "light", ...props }: SliderProps) {
  return (
    // Bottom padding to account for pagination
    <Box pos="relative" pb={8} {...props}>
      <Swiper
        loop
        speed={450}
        modules={[Autoplay, Pagination]}
        autoplay={{
          delay: 10_000,
        }}
        pagination={{
          clickable: true,
          type: "bullets",
          bulletClass: `swiper-pagination-bullet swiper-pagination-bullet--${theme}`,
          bulletActiveClass: `swiper-pagination-bullet-active swiper-pagination-bullet-active--${theme}`,
        }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={`slide-${index}`}>{slide}</SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
}
